import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return (request) =>
    present(
      repository
        .getCapacity(request)
        .then((response) => ({ request, ...response }))
        .catch(() => Promise.reject({ request })),
    );
}

export type { Interactor };

export { createInteractor };
